<script setup lang="ts">
import { svgIcon } from "@/common/components";

withDefaults(
  defineProps<{
    size?: string;
  }>(),
  {
    size: "1.75rem",
  }
);
</script>

<template>
  <div
    class="base-loading"
    :style="{
      width: `calc(${size} + 0.5rem)`,
      height: `calc(${size} + 0.5rem)`,
    }"
  >
    <div class="icon animate spin">
      <svg-icon icon="loading" :size="size" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.base-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .icon {
    color: var(--primary);
  }
}
</style>
